import Column from '@components/Column';

import ShopMap from './ShopMap';
import ShopList from '../ShopList';
import useShopsInMap from './hooks/useShopsInMap';
import styles from './styles.module.scss';

interface Props {
    isOrder?: boolean;
    originalItemId?: string;
}

function MapAndList({ isOrder, originalItemId }:Props) {
  const { markers, shops } = useShopsInMap({
    originalItemId, isOrder,
  });
  return (
        <Column fullWidth fullHeight>
            <div className={styles.map}>
                <ShopMap markers={markers}
                         isOrder={!!isOrder} />
            </div>
            <div className={styles.list}>
                <ShopList isOrder={!!isOrder}
                          originalItemId={originalItemId}
                          shops={shops}
                          isBlank={shops?.length === 0}
                          fit />
            </div>
        </Column>
  );
}

export default MapAndList;
